<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { STATUS_COLOR } from '../helpers';

const props = defineProps({
  status: { type: String, required: true },
  size: { type: String, default: 'sm' },
});
const { t } = useI18n();

const classes = computed(
  () => STATUS_COLOR[props.status] || STATUS_COLOR.draft
);
const label = computed(() => t(`WASAPI_CAMPAIGNS.STATUS.${props.status}`));
</script>

<template>
  <span
    class="inline-flex items-center gap-1.5 font-medium rounded-md whitespace-nowrap"
    :class="[
      classes,
      size === 'lg' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-xs',
    ]"
  >
    <span
      v-if="status === 'processing'"
      class="size-1.5 rounded-full bg-current animate-pulse"
    />
    {{ label }}
  </span>
</template>
